import { render, staticRenderFns } from "./RegisterGraduation.vue?vue&type=template&id=406ec299"
import script from "./RegisterGraduation.vue?vue&type=script&lang=js"
export * from "./RegisterGraduation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports